/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Container,
  Label,
  Button as Btn,
  Input,
  CardText,
  InputGroup
} from "reactstrap";
import Card from "../components/Card/Card.jsx";
import CardHeader from "../components/Card/CardHeader.jsx";
import CardBody from "../components/Card/CardBody.jsx";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { styles } from "../assets/css/styles";
import moment from "moment";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import {
  getUserType,
  utilGetCustomer,
  utilGetInspectionType,
  utilSkipLeapYear
} from "../common/util.js";
import { getVehicle } from "../graphql/queries";
import gql from "graphql-tag";
import * as mutations from "../graphql/mutations";
import { spinnerService } from "@chevtek/react-spinners";
import Radio from "@material-ui/core/Radio";
import Button from "../components/CustomButtons/Button.jsx";
import BuildIcon from "@material-ui/icons/Build";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { green } from "@material-ui/core/colors";
import AddIcon from "@material-ui/icons/Add";
import * as actionTypes from "../redux/actions";
import Select from "react-select";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { Storage } from "aws-amplify";
import Modal from "@material-ui/core/Modal";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Divider from "@material-ui/core/Divider";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { FormGroup } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
const uuidv4 = require("uuid/v4");
let tmpfiles = [];
Storage.configure({
  AWSS3: {
    bucket: "calbitwebappuploadbucket1254-dev", //Your bucket name;
    region: "us-east-2" //Specify the region your bucket was created in;
  }
});
let annualCheck = false;
const keys = [
  "",
  "Engine Compartment",
  "Brake System",
  "Steering",
  "Interior Cab",
  "Lighting / Electrical",
  "Exterior Vehicle",
  "Tires & Rims",
  "Undercarriage Frame",
  "Suspension",
  "Coupling Devices",
  "Safety",
  "Federal Annual Law"
];
const vehicleDefectsInit = [
  {
    name: "Brake System",
    defectsDetailsList: [],
    defects: 0,
    redTagPresent: false
  },
  {
    name: "Coupling Devices",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Exhaust System",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Fuel System",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Lighting Devices",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Safe Loading",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Steering Mechanism",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Suspension",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Frame",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Tires",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Wheels and Rims",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Windshield Glazing",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Windshield Wipers",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  },
  {
    name: "Motor Coach Seats",
    defects: 0,
    defectsDetailsList: [],
    redTagPresent: false
  }
];
const priorityOptions = [
  { value: "HIGH", label: "High" },
  { value: "MEDIUM", label: "Medium" },
  { value: "LOW", label: "Low" }
];
const InspectionCheckData = [
  {
    check: false,
    ObsID: 0,
    name: keys[11],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Chock Wheels",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: false,
    truckAB: false,
    busHB: true,
    truckHB: true,
    tractor: false
  },
  {
    check: false,
    ObsID: 1,
    name: keys[1],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Oil, Coolant, Auto Transmission Levels",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 2,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Hydraulic Brake Fluid Level",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: false,
    truckAB: false,
    busHB: true,
    truckHB: true,
    tractor: false
  },
  {
    check: false,
    ObsID: 3,
    name: keys[3],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "P/W Steering, Steer Hub Oil Level",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 4,
    name: keys[1],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Belts, Fan, Pulleys, Tensioners",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 5,
    name: keys[1],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Filter, Air Filter Tubes and Pipes",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 6,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Compressor Intake/Discharge Hoses/Lines",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 7,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Compressor Signs of Heat and/or Oil",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 8,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Dryer/Governor Condition, Exhaust Port",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 9,
    name: keys[3],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Steering Box Mounts, Leaks, Secured",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 10,
    name: keys[3],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Steering Wheel Lash And Mounts",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 11,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Park Brake Operation, Clutch Free Play",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 12,
    name: keys[4],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Oil, Coolant, Charging, Air Gauges",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 13,
    name: keys[4],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Windshield, Wipers, Mirrors Operation",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 14,
    name: keys[4],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Horn, Defroster, Warning Devices",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 15,
    name: keys[4],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Triangle Box and Fire Extinguisher",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 16,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Hydraulic Brake Operation & Condition",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: true,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: false,
    truckAB: false,
    busHB: true,
    truckHB: true,
    tractor: false
  },
  {
    check: false,
    ObsID: 17,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Electric Brake Operation & Condition",
    busAOH: false,
    truckAOH: false,
    trailerAB: false,
    trailerHB: false,
    trailerEB: true,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: false
  },
  {
    check: false,
    ObsID: 18,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Electric Brake Break-A-Way Operation",
    busAOH: false,
    truckAOH: false,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: false
  },
  {
    check: false,
    ObsID: 19,
    name: keys[5],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "All lights and Reflectors",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 20,
    name: keys[5],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Trailer Plug, Receptacle, Cord, 7-Way",
    busAOH: false,
    truckAOH: false,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 21,
    name: keys[6],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Box/Bed Mounts, Roof/Skin, Mud Flaps",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 22,
    name: keys[7],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Tires - Depths within Spec and Condition",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 23,
    name: keys[7],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Rims, Lugs and Dual Mating",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 24,
    name: keys[1],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Radiator Condition, Hoses, Leaks",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 25,
    name: keys[1],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Engine and Transmission Mounts",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 26,
    name: keys[3],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "King Pins, Steering Arm(s), Tie Rods",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 27,
    name: keys[8],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Exhaust System, Driveline, Carriers",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 28,
    name: keys[9],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "U-Bolts, Shocks, Leafs, Springs",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 29,
    name: keys[9],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Hangers, Torque Arms & Equalizers",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 30,
    name: keys[8],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Frame - Bolts, Welds, Cross Members",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 31,
    name: keys[7],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Hub Oil Levels, Wheel Seals",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 32,
    name: keys[8],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Fuel Tank Mounts, Caps, Hoses",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 33,
    name: keys[5],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "General Engine And Drive Train Leaks",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 34,
    name: keys[8],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Wire & Hoses - Rubbing or Chaffing",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 35,
    name: keys[6],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Lift Gate Operation, Condition",
    busAOH: false,
    truckAOH: false,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: false
  },
  {
    check: false,
    ObsID: 36,
    name: keys[5],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Battery(s) Condition, Connections",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 37,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "ABS Warning Light",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 38,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Low Air Audible And/Or Visual Alarm",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 39,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Compressor Build Up Team",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 40,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Dryer/Governor Purge Cycle",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 41,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Loss-Supply Leakage - Unapplied",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 42,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Loss-Supply Leakage - Applied",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 43,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Tractor Protection System",
    busAOH: false,
    truckAOH: false,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 44,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Tank(s) Mounts And Drained",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 45,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Brake Lines/Hoses Secured",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 46,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Brake Chambers Condition, Mounts",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 47,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Slack(s) Balance, 90 Angle",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 48,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Air Slack Adjuster(s) Stroke within Spec",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 49,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Drums And Rotors Condition",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 50,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Brake Lining(Shoes/Pads) Condition",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 51,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Overall Brake Adjustment",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 52,
    name: keys[10],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Fifth Wheel, Pintle Hooks & Hitches",
    busAOH: false,
    truckAOH: false,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 53,
    name: keys[10],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Fifth Wheel Pin",
    busAOH: false,
    truckAOH: false,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busHB: false,
    truckHB: false,
    tractor: false
  },
  {
    check: false,
    ObsID: 54,
    name: keys[2],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Set Parking Brake",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 55,
    name: keys[11],
    redTagPresent: false,
    defectsDetailsList: [],
    Obs: "Remove Wheel Chocks(Optional)",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  }
];
let DefectiveObservations = [];
let SelectedObservations = [];
const date = new Date();
let observedMileage = "";
const GreenRadio = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600]
    }
  },
  checked: {}
})(props => <Radio color="default" {...props} />);

const InspectionList = props => {
  //
  const [vehicle, setVehicle] = useState({});
  const [inspectionObservations, setInspectionObservations] = useState([]);
  const [vehicleDefects, setVehicleDefects] = useState(vehicleDefectsInit);
  const [disabled, setDisabled] = useState({
    defective: [],
    ok: []
  });
  const [prevInspections, setPrevInspections] = useState([]);
  const [screen, setScreen] = useState(0);
  const [select, setSelect] = useState(false);
  const [priority, setPriority] = useState("");
  let [selecttedDefect, setSelectedDefect] = useState({});
  const [detail, setDetail] = useState("");
  const [defectsArray, setDefectsArray] = useState([]);
  const [inspPassed, setinspPassed] = useState(false);
  const [inspFailed, setinspFailed] = useState(false);
  const [files, setFiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(-1);
  const [mode, setMode] = useState("Add");
  const [listDefects, setListDefects] = useState([]);
  const [curentDefect, setCurentDefect] = useState({});
  const [updateIndex, setUpdateIndex] = useState(-1);
  const [inspType, setInspType] = useState(
    props.location.state !== undefined ? props.location.state.inspType : ""
  );
  const [mileageValue, setMileageValue] = useState(
    props.location.state !== undefined ? props.location.state.mileage : 0
  );
  const [regType, setRegType] = useState("");
  const [removeDialog, setRemoveDialog] = useState(false);
  const [tobeRemoved, setTobeRemoved] = useState("");
  let [startDate, setStartDate] = useState(new Date());
  let [endDate, setEndDate] = useState(new Date());
  const [dateEditor, setDateEditor] = useState("");
  let [dialog, setDialog] = useState(false);
  let [dialogCheck, setDialogCheck] = useState(false);
  const [vehicleType, setVehicleType] = useState("");
  const [inspectionResult, setInspectionResult] = useState("");
  let [formFile, setFormFile] = useState({});
  let [reportFile, setReportFile] = useState({});
  const [vehicleStatus, setVehicleStatus] = useState("");
  let formUpload = null;
  let reportUpload = null;
  let today = new Date();
  let month =
    today.getMonth() + 1 < 10
      ? `0${today.getMonth() + 1}`
      : today.getMonth() + 1;
  let date = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();

  const loadInspection = async id => {
    spinnerService.show("mySpinner");
    await clearAllData();
    try {
      const { client } = props;
      const data = await client.query({
        query: gql(getVehicle),
        fetchPolicy: `network-only`,
        variables: { id }
      });
      const vehicle = data.data.getVehicle ? data.data.getVehicle : [];

      if (vehicle.inspections.items.length > 0) {
        let temp = [];
        vehicle.inspections.items.map(i => {
          temp.push(new Date(i.endAt));
        });
        setPrevInspections(temp);
      }
      setScreen(2);
      setVehicle(vehicle);
      setVehicleStatus(vehicle.vehicleStatus);
      setRegType(vehicle.customer.registeredInspectionType);
      setVehicleType(vehicle.vehicleType.vehicleType);
      spinnerService.hide("mySpinner");
    } catch (error) {
      spinnerService.hide("mySpinner");
    }
  };

  const addDefectDetail = async () => {
    spinnerService.show("mySpinner");

    if (detail === "") {
      toast.error("Defect description can not be blank");
      spinnerService.hide("mySpinner");
      return;
    }
    if (priority === "") {
      toast.error("Please select priority of defect");
      spinnerService.hide("mySpinner");
      return;
    }
    await uploadImages();
    let { defectsDetailsList, Obs } = selecttedDefect;
    // if (defectsDetailsList.length > 1) defectsDetailsList.pop();
    DefectiveObservations.push(Obs);
    SelectedObservations = SelectedObservations.filter(o => o !== Obs);
    defectsDetailsList.push({
      detail,
      redTag: select,
      priority,
      defectUpload: tmpfiles
    });

    setSelectedDefect({
      ...selecttedDefect,
      defectsDetailsList,
      defectUpload: tmpfiles,
      redTagPresent: select ? true : false
    });

    // select && setSelectedDefect({ ...selecttedDefect, redTagPresent: true });
    // let defs = [...defectsArray];
    let defs = defectsArray;
    defs = defs.filter(def => def.Obs !== selecttedDefect.Obs);
    defs.push(selecttedDefect);
    defs = new Set(defs);
    defs = [...defs];
    // defs = selecttedDefect;

    setDefectsArray(defs);
    setDetail("");
    setPriority("");
    // setSelectedDefect({});
    setSelect(false);
    setFiles([]);
    tmpfiles = [];
    // document.getElementById("head").focus();
    // setScreen(2);
    spinnerService.hide("mySpinner");
  };

  const handleObservatations = value => {
    if (SelectedObservations.includes(value)) {
      SelectedObservations = SelectedObservations.filter(val => val !== value);
      if (disabled.defective.includes(value)) {
        let temp = disabled.defective.filter(dd => dd !== value);
        setDisabled({
          ...disabled,
          defective: temp
        });
      }
    } else {
      SelectedObservations.push(value);
      setDisabled({
        ...disabled,
        defective: SelectedObservations
      });
    }
    setInspectionObservations(SelectedObservations);
  };
  const handleSubmit = async checkInsp => {
    let inspectionStatus = "PASSED_NODEFECTFOUND";
    let vehStatus = vehicleStatus;
    let notNew = false;
    // await prevInspections.map(i => {
    //   if (moment(new Date(i)).diff(new Date(endDate), "days") === 0) {
    //     notNew = true;
    //     return;
    //   }
    // });
    if (notNew) {
      toast.error("Inspection Already Done for Specified Date");
      return;
    }
    if (checkInsp === "failed") {
      if (defectsArray.length <= 0) {
        toast.error("Please add atleast one defect to proceed");
        return;
      }
      // if (notNew) {
      //   toast.error("Inspection Already Done for Specified Date");
      //   return;
      // }
      if (defectsArray.length > 0) {
        let redTag = false;
        defectsArray.map(selectedDef => {
          selectedDef.defectsDetailsList.map(def => {
            if (def.redTag === true) redTag = true;
          });
        });
        if (redTag) {
          inspectionStatus = "FAILED_REDTAGGED";
          vehStatus = "OUTOFSERVICE";
          setVehicleStatus("OUTOFSERVICE");
        } else inspectionStatus = "FAILED_REGULARREPAIR";
      }
      //  if (defectsArray.length > 0) {
      //   let redTag = false;
      //   defectsArray.map(selectedDef => {
      //     if (selectedDef.redTagPresent === true) redTag = true;
      //   });
      //   if (redTag) {
      //     inspectionStatus = "FAILED_REDTAGGED";
      //     vehStatus = "OUTOFSERVICE";
      //     setVehicleStatus("OUTOFSERVICE");
      //   } else inspectionStatus = "FAILED_REGULARREPAIR";
      // } else {
      //   toast.error("Please add atleast one defect to proceed");
      //   return;
      // }
    }

    let { client, user, profile } = props;
    if (profile === undefined || profile === "" || profile === null) {
      if (
        props.location.state &&
        (props.location.state.vendor || props.location.state.mech)
      ) {
        // profile = regType;
      } else {
        profile = await utilGetCustomer(user, client);
        props.storeProfile(profile);
      }
    }
    let id = uuidv4();
    let userType = getUserType(user);

    let inspectionType = "";
    if (regType === "FEDERAL_BIT") {
      if (inspType === "DOT") {
        if (
          vehicle.nextInspectionDue &&
          vehicle.nextInspectionDue.length <= 0
        ) {
          // inspectionType = utilGetInspectionType(
          //   profile.registeredInspectionType
          // );
          inspectionType = "DOT_ANNUAL_INSPECTION";
        } else {
          // inspectionType = !vehicle.nextInspectionDue
          //   ? utilGetInspectionType(profile.registeredInspectionType)
          //   : vehicle.nextInspectionDue[0].inspectionType;
          inspectionType = "DOT_ANNUAL_INSPECTION";
        }
      } else if (inspType === "BIT") {
        if (
          vehicle.nextInspectionDue &&
          vehicle.nextInspectionDue.length <= 0
        ) {
          // inspectionType = utilGetInspectionType(
          //   profile.registeredInspectionType
          // );
          inspectionType = "BIT_90DAY_INSPECTION";
        } else if (
          vehicle.nextInspectionDue &&
          vehicle.nextInspectionDue.length <= 1
        ) {
          // inspectionType = !vehicle.nextInspectionDue
          //   ? utilGetInspectionType(profile.registeredInspectionType)
          //   : vehicle.nextInspectionDue[0].inspectionType;
          inspectionType = "BIT_90DAY_INSPECTION";
        } else {
          // inspectionType = !vehicle.nextInspectionDue
          //   ? utilGetInspectionType(profile.registeredInspectionType)
          //   : vehicle.nextInspectionDue[1].inspectionType;
          inspectionType = "BIT_90DAY_INSPECTION";
        }
      } else if (inspType === "DOTANDBIT") {
        if (
          vehicle.nextInspectionDue &&
          vehicle.nextInspectionDue.length <= 0
        ) {
          // inspectionType = utilGetInspectionType(
          //   profile.registeredInspectionType
          // );
          inspectionType = "DOTANDBIT";
        } else {
          // inspectionType = !vehicle.nextInspectionDue
          //   ? utilGetInspectionType(profile.registeredInspectionType)
          //   : "DOTANDBIT";
          inspectionType = "DOTANDBIT";
        }
      }
    } else {
      if (vehicle.nextInspectionDue && vehicle.nextInspectionDue.length <= 0) {
        inspectionType = utilGetInspectionType(regType);
      } else {
        inspectionType = !vehicle.nextInspectionDue
          ? utilGetInspectionType(regType)
          : vehicle.nextInspectionDue[0].inspectionType;
      }
    }
    let inspDate = "";
    if (regType === "FEDERAL_BIT") {
      if (inspType === "DOT") {
        if (
          vehicle.nextInspectionDue &&
          vehicle.nextInspectionDue.length <= 0
        ) {
          inspDate = endDate;
        } else {
          if (
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[0].nextDueDate === null) ||
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[0].nextDueDate === "") ||
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[0].nextDueDate === undefined)
          )
            inspDate = endDate;
          else inspDate = !vehicle.nextInspectionDue ? endDate : endDate; //vehicle.nextInspectionDue[0].nextDueDate;
        }
      } else if (inspType === "BIT") {
        if (
          vehicle.nextInspectionDue &&
          vehicle.nextInspectionDue.length <= 1
        ) {
          inspDate = endDate;
        } else {
          if (
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[1].nextDueDate === null) ||
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[1].nextDueDate === "") ||
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[1].nextDueDate === undefined)
          )
            inspDate = endDate;
          else inspDate = !vehicle.nextInspectionDue ? endDate : endDate; //vehicle.nextInspectionDue[0].nextDueDate;
        }
      } else if (inspType === "DOTANDBIT") {
        if (
          vehicle.nextInspectionDue &&
          vehicle.nextInspectionDue.length <= 1
        ) {
          inspDate = endDate;
        } else {
          if (
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[1].nextDueDate === null) ||
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[1].nextDueDate === "") ||
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[1].nextDueDate === undefined) ||
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[0].nextDueDate === null) ||
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[0].nextDueDate === "") ||
            (vehicle.nextInspectionDue &&
              vehicle.nextInspectionDue[0].nextDueDate === undefined)
          )
            inspDate = endDate;
          else inspDate = !vehicle.nextInspectionDue ? endDate : endDate; //vehicle.nextInspectionDue[0].nextDueDate;
        }
      }
    } else {
      if (vehicle.nextInspectionDue && vehicle.nextInspectionDue.length <= 0) {
        inspDate = endDate;
      } else {
        if (
          (vehicle.nextInspectionDue &&
            vehicle.nextInspectionDue[0].nextDueDate === null) ||
          (vehicle.nextInspectionDue &&
            vehicle.nextInspectionDue[0].nextDueDate === "") ||
          (vehicle.nextInspectionDue &&
            vehicle.nextInspectionDue[0].nextDueDate === undefined)
        )
          inspDate = endDate;
        else inspDate = !vehicle.nextInspectionDue ? endDate : endDate; //vehicle.nextInspectionDue[0].nextDueDate;
      }
    }

    //let inspDate = vehicle.nextInspectionDue && vehicle.nextInspectionDue[0].nextDueDate;
    // const nextInspectionDue =
    //   inspectionType === "DOT_ANNUAL_INSPECTION"
    //     ? moment(inspDate).add(1, "year")
    //     : inspectionType === "BIT_90DAY_INSPECTION"
    //     ? moment(inspDate).add(90, "days")
    //     : moment(inspDate).add(45, "days");
    let _nextInspectionDue_;
    let _nextInspectionDue_Arr;
    // let _nextInspectionDue_ = utilSkipLeapYear(inspectionType, inspDate);
    // let _nextInspectionDue_Arr = utilSkipLeapYear("DOTANDBIT", inspDate);
    if (inspType === "DOTANDBIT") {
      _nextInspectionDue_Arr = utilSkipLeapYear("DOTANDBIT", inspDate);
    } else {
      _nextInspectionDue_ = utilSkipLeapYear(inspectionType, inspDate);
    }
    await uploadFiles();

    let input = {
      id,
      customerId: vehicle.customer.id,
      // customerId: profile.id,
      vehicleId: props.match.params.id,
      inspectionVehicleId: props.match.params.id,
      // inspectorUserType: profile.companyName,
      // priority,
      inspectionType,
      // startAt,
      // endAt: new Date(),
      startAt: startDate,
      endAt: endDate,
      // nextInspectionDue: nextInspectionDue.toISOString().split("T")[0],
      nextInspectionDue:
        inspType !== "DOTANDBIT"
          ? _nextInspectionDue_
          : new Date().toISOString().split("T")[0],
      inspectionObservations,
      inspectorUserType: userType,
      inspectorUserId: user.username,
      inspectionStatus,
      inspectionForm: formUpload,
      inspectionReport: reportUpload,
      federalStickerUpdated: annualCheck
    };
    let mutationData = "";
    let inspData = "";
    let inspOTFToken =
      props.match.params.type === "insp" ? "Inspection" : "Defects";
    try {
      spinnerService.show("mySpinner");
      if (checkInsp !== "PASSED_NODEFECTFOUND") {
        await saveDefects(input, inspectionStatus, userType, user, client);
      }
      if (props.match.params.type === "insp") {
        try {
          inspData = await client.mutate({
            mutation: gql(mutations.createInspection),
            variables: {
              input
            }
          });
        } catch (err) {
          spinnerService.hide("mySpinner");
          return;
        }

        setFormFile({});
        setReportFile({});
        formUpload = null;
        reportUpload = null;

        if (regType === "FEDERAL_BIT") {
          if (inspType === "DOT") {
            try {
              mutationData = await client.mutate({
                mutation: gql(mutations.updateVehicle),
                variables: {
                  input: {
                    id: input.vehicleId,
                    nextInspectionDue: [
                      {
                        inspectionType: input.inspectionType,
                        nextDueDate: input.nextInspectionDue
                      },
                      {
                        inspectionType: "BIT_90DAY_INSPECTION",
                        nextDueDate:
                          vehicle.nextInspectionDue.length > 1
                            ? vehicle.nextInspectionDue[1].nextDueDate
                            : vehicle.nextInspectionDue[0].nextDueDate
                      }
                    ]
                  },
                  currentMileage: mileageValue,
                  vehicleStatus: vehStatus
                }
              });
            } catch (err) {
              spinnerService.hide("mySpinner");
              return;
            }
          } else if (inspType === "BIT") {
            try {
              mutationData = await client.mutate({
                mutation: gql(mutations.updateVehicle),
                variables: {
                  input: {
                    id: input.vehicleId,
                    nextInspectionDue: [
                      {
                        inspectionType: "DOT_ANNUAL_INSPECTION",
                        nextDueDate: vehicle.nextInspectionDue[0].nextDueDate
                      },
                      {
                        inspectionType: input.inspectionType,
                        nextDueDate: input.nextInspectionDue
                      }
                    ]
                  },
                  currentMileage: mileageValue,
                  vehicleStatus: vehStatus
                }
              });
            } catch (err) {
              spinnerService.hide("mySpinner");
              return;
            }
          } else if (
            inspType === "DOTANDBIT" &&
            inspectionStatus !== "PASSED_NODEFECTFOUND"
          ) {
            try {
              mutationData = await client.mutate({
                mutation: gql(mutations.updateVehicle),
                variables: {
                  input: {
                    id: input.vehicleId,
                    nextInspectionDue: [
                      {
                        inspectionType: "DOT_ANNUAL_INSPECTION",
                        nextDueDate: new Date(_nextInspectionDue_Arr[0])
                          .toISOString()
                          .split("T")[0]
                      },
                      {
                        inspectionType: "BIT_90DAY_INSPECTION",
                        nextDueDate: new Date(_nextInspectionDue_Arr[1])
                          .toISOString()
                          .split("T")[0]
                      }
                    ]
                  },
                  currentMileage: mileageValue,
                  vehicleStatus: vehStatus
                }
              });
            } catch (err) {
              spinnerService.hide("mySpinner");
              return;
            }
          }
        } else {
          try {
            mutationData = await client.mutate({
              mutation: gql(mutations.updateVehicle),
              variables: {
                input: {
                  id: input.vehicleId,
                  nextInspectionDue: {
                    inspectionType: input.inspectionType,
                    nextDueDate: input.nextInspectionDue
                  },
                  currentMileage: mileageValue,
                  vehicleStatus: vehStatus
                }
              }
            });
          } catch (err) {
            spinnerService.hide("mySpinner");
            return;
          }
        }
      }
      spinnerService.hide("mySpinner");
      toast.success(inspOTFToken + " Added");
      await clearAllData();
      await setSelectedDefect({});
      // props.history.goBack();
      if (props.match.params.type !== "otf") {
        if (props.location.state && props.location.state.mech) {
          props.history.push(
            `/mech/customer/${props.match.params.cId}/vehicle/${props.match.params.id}`,
            {
              focus: "Insp"
            }
          );
        } else
          props.history.push(`/company/vehicle/${props.match.params.id}`, {
            focus: "Insp"
          });
      } else {
        if (props.location.state && props.location.state.mech) {
          props.history.push(
            `/mech/customer/${props.match.params.cId}/vehicle/${props.match.params.id}`
          );
        } else props.history.push(`/company/vehicle/${props.match.params.id}`);
      }
    } catch (error) {
      toast.error(
        inspOTFToken +
          " could not be saved at this time. Please try again later."
      );
      spinnerService.hide("mySpinner");
    }
  };

  const saveDefects = async (inspInput, status, userType, user, client) => {
    if (defectsArray.length <= 0) return;
    let defects = new Array();
    let sourceType =
      props.match.params.type === "insp" ? "INSPECTION" : "ONTHEFLY";

    let defInput = {};
    defectsArray.map(selecttedDefect => {
      selecttedDefect.defectsDetailsList.map(item => {
        let defId = uuidv4();
        defInput = {
          id: defId,
          customerId: inspInput.customerId,
          vehicleId: inspInput.vehicleId,
          defectType: selecttedDefect.name,
          defectDesc: item.detail,
          redTag: item.redTag,
          priority: item.priority.value,
          status: "OPEN",
          reportedByUserType: userType,
          reportedByUserId: user.username,
          reportedDateTime: endDate,
          sourceType,
          defectUploads: item.defectUpload,
          defectVehicleId: inspInput.vehicleId
        };

        if (props.match.params.type === "insp")
          defInput.sourceId = inspInput.id;
        defects.push(defInput);
        defInput = {};
      });
    });
    try {
      const defData = await client.mutate({
        mutation: gql(mutations.batchAddDefects),
        variables: {
          defects
        }
      });
    } catch (error) {
      throw error;
    }
  };
  const clearAllData = async () => {
    await setDefectsArray([]);
    await setSelectedDefect({});
    await setSelectedDefect({
      check: "",
      ObsID: "",
      name: "",
      redTagPresent: "",
      defectsDetailsList: [],
      Obs: "",
      busAOH: "",
      truckAOH: "",
      trailerAB: "",
      trailerHB: "",
      trailerEB: "",
      rv: "",
      van: "",
      pickup: "",
      limo: "",
      busAB: "",
      truckAB: "",
      busHB: "",
      truckHB: "",
      tractor: ""
    });
    let { defectsDetailsList } = selecttedDefect;
    defectsDetailsList = [];
    setInspectionObservations([]);
    SelectedObservations = [];
    DefectiveObservations = [];
    //setVehicle(null);
    InspectionCheckData.map(item => {
      item.check = false;
    });
    let _vehicleDefects = [...vehicleDefects];
    _vehicleDefects.map(item => {
      item.defects = 0;
      item.defectsDetailsList = [];
      item.redTagPresent = false;
    });
    setVehicleDefects(_vehicleDefects);
  };
  const uploadImages = async () => {
    if (files.length === 0) {
      return;
    }

    return await Promise.all(
      files.length !== 0 &&
        files.map(async (item, index) => {
          try {
            if (!item.key) {
              let key = await Storage.put(
                new Date().getTime() + item.name,
                item
              );
              tmpfiles.push({
                bucket: "calbitwebappuploadbucket1254-dev",
                region: "us-east-2",
                key: key.key
              });
            }
          } catch (err) {}
          // }
        })
    );
  };
  const fileSelect = e => {
    let file = e.target.files[0];
    let tmpfiles = [...files];
    tmpfiles.push(file);
    setFiles(tmpfiles);
    // let url=URL.createObjectURL(file);
  };
  const removeFile = (item, i) => {
    let list = [...listDefects];

    let tmpfiles = [...files];
    if (tmpfiles[i].key) {
      //send delete request here
      list[index].defectsDetailsList[updateIndex].defectUpload.splice(i, 1);
      setListDefects(list);
    }
    tmpfiles.splice(i, 1);
    setFiles(tmpfiles);
  };
  const showDefetsDetail = () => {
    let list = [];
    defectsArray.map(defect => {
      let no = 0;
      list.map(item => {
        if (item.name === defect.name && item.Obs === defect.Obs) {
          // list.push(defect);
          no = no + 1;
        }
      });
      if (no === 0) {
        list.push(defect);
      }
    });

    setListDefects(list);
  };
  const removeDefect = i => {
    let list = [...listDefects];
    list[index].defectsDetailsList.splice(i, 1);

    setListDefects(list);
    if (list[index].defectsDetailsList.length <= 0) {
      DefectiveObservations = DefectiveObservations.filter(
        o => o !== list[index].Obs
      );
      setOpen(false);
    }
  };
  const _removeDefect = i => {
    let list = selecttedDefect;
    list.defectsDetailsList.splice(i, 1);

    setSelectedDefect(list);
    if (list.defectsDetailsList.length <= 0) {
      DefectiveObservations = DefectiveObservations.filter(o => o !== list.Obs);
    }
    setRemoveDialog(false);
  };
  const showEdit = i => {
    let list = [...listDefects];
    setCurentDefect(list[index].defectsDetailsList[i]);
    setDetail(list[index].defectsDetailsList[i].detail);
    setPriority(list[index].defectsDetailsList[i].priority);
    setSelect(list[index].defectsDetailsList[i].redTag);
    tmpfiles = list[index].defectsDetailsList[i].defectUpload;

    // document.getElementById("head").focus();
    setScreen(6);
    setOpen(false);
    setUpdateIndex(i);
    setFiles(tmpfiles);
  };

  const _showEdit = i => {
    let list = selecttedDefect;
    setCurentDefect(list.defectsDetailsList[i]);
    setDetail(list.defectsDetailsList[i].detail);
    setPriority(list.defectsDetailsList[i].priority);
    setSelect(list.defectsDetailsList[i].redTag);
    tmpfiles = list.defectsDetailsList[i].defectUpload;

    // document.getElementById("head").focus();
    setScreen(4);
    setOpen(false);
    setUpdateIndex(i);
    setFiles(tmpfiles);
  };
  const _closeEdit = async () => {
    let list = selecttedDefect;
    const updatedArray = defectsArray;
    await uploadImages();
    list.defectsDetailsList[updateIndex] = {
      priority,
      detail,
      redTag: select,
      defectUpload: tmpfiles
    };
    defectsArray.map((defect, j) => {
      // list.map((item, k) => {
      if (list.name == defect.name && list.Obs == defect.Obs)
        updatedArray[j] = list;
      // });
    });
    setDefectsArray(updatedArray);
    setSelectedDefect(list);
    // document.getElementById("head").focus();
    setDetail("");
    setPriority("");
    setSelect(false);
    setScreen(4);
    setMode("Add");
    tmpfiles = [];
    setFiles([]);
  };
  const closeEdit = async () => {
    let list = [...listDefects];
    const updatedArray = defectsArray;
    await uploadImages();
    list[index].defectsDetailsList[updateIndex] = {
      priority,
      detail,
      redTag: select,
      defectUpload: tmpfiles
    };
    defectsArray.map((defect, j) => {
      list.map((item, k) => {
        if (item.name == defect.name && item.Obs == defect.Obs)
          updatedArray[j] = item;
      });
    });
    setDefectsArray(updatedArray);
    setListDefects(list);
    // document.getElementById("head").focus();
    setScreen(5);
    tmpfiles = [];
    setFiles([]);
  };
  const showModal = index => {
    setIndex(index);
    setOpen(true);
  };
  useEffect(() => {
    loadInspection(props.match.params.id);
    if (props.match.params.type === "otf") {
      // document.getElementById("head").focus();
      setScreen(2);
    }
  }, []);
  let { user } = props;

  const uploadFiles = async () => {
    if (formFile.name) {
      let key = await Storage.put(
        new Date().getTime() + formFile.name,
        formFile
      );
      formUpload = {
        bucket: "calbitwebappuploadbucket1254-dev",
        region: "us-east-2",
        key: key.key
      };
      // setFormFile(formUpload);
    }
    if (reportFile.name) {
      let key = await Storage.put(
        new Date().getTime() + reportFile.name,
        reportFile
      );
      reportUpload = {
        bucket: "calbitwebappuploadbucket1254-dev",
        region: "us-east-2",
        key: key.key
      };
      // setReportFile(reportFile);
    }
  };

  const submitHandler = (status, inspType) => {
    setInspectionResult(status);
    if (status === "failed") {
      if (defectsArray.length <= 0) {
        toast.error("Please add atleast one defect to proceed");
        return;
      }
      if (
        prevInspections.includes(new Date(endDate)) ||
        prevInspections.includes(endDate)
      ) {
        toast.error("Inspection On Specified Date has Already Been Done");
        return;
      }
    }
    if (["DOT", "DOTANDBIT"].includes(inspType)) {
      // if (federalAnnual.status !== true) {
      setDialogCheck(true);
      // } else {
      //   handleSubmit(status);
      // }
    } else {
      handleSubmit(status);
    }
  };

  const handleSelectedDefect = item => {
    // if (DefectiveObservations.includes(item.Obs)) {
    //   DefectiveObservations = DefectiveObservations.filter(o => o !== item.Obs);
    // } else {
    setSelectedDefect(item);
    setScreen(4);
    // }
  };

  // Screens & Views

  const DateEditorDialog = () => {
    let startAt = new Date(startDate);
    let endAt = new Date(endDate);
    const handleDateEdit = event => {
      const { id, value } = event.target;
      if (id === "startDate" && dateEditor === "startDate") {
        if (moment(new Date(value)).isAfter(new Date(endDate))) {
          startAt = new Date(value);
          setStartDate(startAt);
          setStartDate(new Date(value));
          endAt = new Date(value);
          setEndDate(new Date(value));
          setEndDate(endAt);
        } else {
          startAt = new Date(value);
          setStartDate(startAt);
          setStartDate(new Date(value));
        }
      }
      if (id === "endDate" && dateEditor === "endDate") {
        if (moment(new Date(value)).isBefore(new Date(startDate))) {
          startAt = new Date(value);
          setStartDate(startAt);
          setStartDate(new Date(value));
          endAt = new Date(value);
          setEndDate(new Date(value));
          setEndDate(endAt);
        } else {
          endAt = new Date(value);
          setEndDate(new Date(value));
          setEndDate(endAt);
        }
      }
      // setDialog(false);
      // setStartDate(startAt);
      // setEndDate(endAt);
    };
    const handleClose = () => {
      setDialog(false);
      setStartDate(startAt);
      setEndDate(endAt);
    };
    return (
      <div>
        <Dialog
          open={dialog}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Edit Inspection Dates
          </DialogTitle>
          <DialogContent>
            {dateEditor === "startDate" && (
              <InputGroup className="input-group-alternative mb-2">
                <Label for="startDate">Start Date</Label>
                <Input
                  id="startDate"
                  type="date"
                  onChange={handleDateEdit}
                  value={
                    moment(startDate)
                      .toISOString()
                      .split("T")[0]
                  }
                  required
                />
              </InputGroup>
            )}
            {dateEditor === "endDate" && (
              <InputGroup className="input-group-alternative mb-2">
                <Label for="endDate">End Date</Label>
                <Input
                  id="endDate"
                  type="date"
                  onChange={handleDateEdit}
                  value={
                    moment(endDate)
                      .toISOString()
                      .split("T")[0]
                  }
                  required
                />
              </InputGroup>
            )}
          </DialogContent>
          <DialogActions>
            <div>
              <Button onClick={handleClose}>Set Date</Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const InspectionTypeDisplay = () => (
    <React.Fragment>
      {props.match.params.type === "insp" && (
        <React.Fragment>
          {inspType === "DOT" && (
            <React.Fragment>
              <div style={{ fontWeight: "bold" }}>
                {[null, undefined].includes(vehicle.nextInspectionDue) ||
                vehicle.nextInspectionDue.length === 0
                  ? ""
                  : vehicle.nextInspectionDue[0].inspectionType ===
                      "DOT_ANNUAL_INSPECTION" && "DOT Annual Inspection"}
              </div>
              <div style={{ fontWeight: "bold" }}>
                {[null, undefined].includes(vehicle.nextInspectionDue) ||
                vehicle.nextInspectionDue.length === 0
                  ? ""
                  : "Next Due: " +
                    moment(vehicle.nextInspectionDue[0].nextDueDate).format(
                      "MM-DD-YYYY"
                    )}
              </div>
            </React.Fragment>
          )}
          {inspType === "BIT" && regType === "FEDERAL_BIT" && (
            <React.Fragment>
              <div style={{ fontWeight: "bold" }}>
                {[null, undefined].includes(vehicle.nextInspectionDue) ||
                vehicle.nextInspectionDue.length === 0
                  ? ""
                  : vehicle.nextInspectionDue.length <= 1
                  ? vehicle.nextInspectionDue[0].inspectionType ===
                      "BIT_90DAY_INSPECTION" && "BIT 90 Day Inspection"
                  : vehicle.nextInspectionDue[1].inspectionType ===
                      "BIT_90DAY_INSPECTION" && "BIT 90 Day Inspection"}
              </div>
              <div style={{ fontWeight: "bold" }}>
                {[null, undefined].includes(vehicle.nextInspectionDue) ||
                vehicle.nextInspectionDue.length === 0
                  ? " "
                  : vehicle.nextInspectionDue.length <= 1
                  ? " "
                  : "Next Due: " +
                    moment(vehicle.nextInspectionDue[1].nextDueDate).format(
                      "MM-DD-YYYY"
                    )}
              </div>
            </React.Fragment>
          )}
          {inspType === "BIT" && regType !== "FEDERAL_BIT" && (
            <React.Fragment>
              <div style={{ fontWeight: "bold" }}>
                {[null, undefined].includes(vehicle.nextInspectionDue) ||
                vehicle.nextInspectionDue.length === 0
                  ? ""
                  : vehicle.nextInspectionDue[0].inspectionType ===
                      "BIT_90DAY_INSPECTION" && "BIT 90 Day Inspection"}
              </div>
              <div style={{ fontWeight: "bold" }}>
                {[null, undefined].includes(vehicle.nextInspectionDue) ||
                vehicle.nextInspectionDue.length === 0
                  ? ""
                  : "Next Due: " +
                    moment(vehicle.nextInspectionDue[0].nextDueDate).format(
                      "MM-DD-YYYY"
                    )}
              </div>
            </React.Fragment>
          )}
          {inspType === "DOTANDBIT" && regType === "FEDERAL_BIT" && (
            <React.Fragment>
              <div style={{ fontWeight: "bold" }}>
                {[null, undefined].includes(vehicle.nextInspectionDue) ||
                vehicle.nextInspectionDue.length < 2
                  ? " "
                  : "DOT & BIT Inspection"}
              </div>
              <div style={{ fontWeight: "bold" }}>
                {!vehicle.nextInspectionDue ||
                (vehicle.nextInspectionDue === undefined &&
                  vehicle.nextInspectionDue.length === 0)
                  ? ""
                  : "DOT Next Due: " +
                    moment(vehicle.nextInspectionDue[0].nextDueDate).format(
                      "MM-DD-YYYY"
                    )}
              </div>
              <div style={{ fontWeight: "bold" }}>
                {!vehicle.nextInspectionDue ||
                (vehicle.nextInspectionDue === undefined &&
                  vehicle.nextInspectionDue.length < 2)
                  ? " "
                  : vehicle.nextInspectionDue.length > 1 &&
                    "BIT Next Due: " +
                      moment(vehicle.nextInspectionDue[1].nextDueDate).format(
                        "MM-DD-YYYY"
                      )}
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );

  const HeaderDisplay = () => {
    return (
      <Row>
        <Col sm={4}>
          <div style={{ float: "left" }}>
            {props.match.params.type === "insp" && (
              <h4
                style={{ fontWeight: "bold" }}
                className={styles.cardTitleWhite}
                id="head"
              >
                Inspection Wizard
              </h4>
            )}
            {props.match.params.type === "otf" && (
              <h4
                style={{ fontWeight: "bold" }}
                className={styles.cardTitleWhite}
              >
                On the Fly Reporting
              </h4>
            )}
            <div>{`${moment(new Date()).format("dddd DD MMMM YYYY")}`}</div>
            <div>
              <Row>
                <Col>
                  {vehicle.vehicleType && vehicle.vehicleType.vehicleType}{" "}
                </Col>
              </Row>
              <Row>
                <Col>(ID:{vehicle.customerVehicleId})</Col>
              </Row>
            </div>
          </div>
        </Col>

        <Col sm={4}>
          <div>
            {props.match.params.type === "insp" && (
              <div style={{ marginTop: "-10px" }}>
                <h2>{user.username}</h2>
                <h6 style={{ marginTop: "-15px" }}>DOT/BIT Inspector</h6>
              </div>
            )}
            {props.match.params.type === "otf" && (
              <div style={{ marginTop: "-10px" }}>
                <h2>{user.username}</h2>
                <h6 style={{ marginTop: "-15px" }}>DOT/BIT Inspector</h6>
              </div>
            )}
          </div>
        </Col>
        <Col sm={4} style={{ float: "right", paddingLeft: "6%" }}>
          <div>User Role: {getUserType(user)}</div>
          <InspectionTypeDisplay />
        </Col>
      </Row>
    );
  };

  const RemoveDialog = () => {
    return (
      <Dialog
        open={removeDialog}
        onClose={() => setRemoveDialog(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Remove Defect </DialogTitle>
        <DialogActions>
          <Button onClick={() => setRemoveDialog(false)} color="info">
            No
          </Button>
          <Button onClick={() => _removeDefect(tobeRemoved)} color="info">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const AnnualCheckDialog = () => {
    const setStatus = res => {
      if (res === "n") {
        annualCheck = false;
      }
      if (res === "y") {
        annualCheck = true;
      }
      handleSubmit(inspectionResult);
      setDialogCheck(false);
    };
    const handleClose = () => {
      setDialogCheck(false);
    };
    return (
      <div>
        <Dialog
          open={dialogCheck}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth="true"
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">
            Annual Federal Check
          </DialogTitle>
          <DialogContent>
            <div style={{ fontWeight: "bold", margin: 2 }}>
              <Row>
                <Col>
                  <FormGroup row>
                    <Typography variant="body2">
                      Update Federal Annual Sticker ?
                    </Typography>
                  </FormGroup>
                  {/* {federalAnnual.err && (
                    <text
                      style={{
                        color: "red",
                        fontSize: 12,
                        marginLeft: 10
                      }}
                    >
                      This Check is Required
                    </text>
                  )} */}
                </Col>
              </Row>
            </div>
          </DialogContent>
          <DialogActions>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button color="info" onClick={() => setStatus("n")}>
                No, Submit
              </Button>
              <Button color="success" onClick={() => setStatus("y")}>
                Yes, Submit
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const RenderInspResultScreen = () => {
    return (
      <div>
        {/* <h4>Select Inspection type</h4> */}
        <h4>Inspection Type</h4>
        <Row>
          <Col sm={6}>
            <Card
              body
              onClick={e => {
                if (inspPassed === false) setinspFailed(false);
                setinspPassed(!inspPassed);
              }}
              style={{
                borderWidth: inspPassed === true ? "2px" : "thin",
                borderColor: "green"
              }}
            >
              <CardText style={{ textAlign: "center" }}>
                <GreenRadio
                  // checked={inspPassed === true}
                  checked={inspectionResult === "passed"}
                  onChange={e => {
                    if (inspPassed === false) setinspFailed(false);
                    setinspPassed(!inspPassed);
                  }}
                  // value="BIT"
                  id="selectedInspectionType"
                  name="radio-button-demo"
                  inputProps={{ "aria-label": "C" }}
                />
                <h4>Passed</h4> <h4>No Defects Found</h4>
              </CardText>
            </Card>
          </Col>
          <Col sm={6}>
            <Card
              body
              onClick={e => {
                if (inspFailed === false) setinspPassed(false);
                setinspFailed(!inspFailed);
              }}
              style={{
                borderWidth: inspFailed === true ? "2px" : "thin",
                borderColor: "green"
              }}
            >
              <CardText style={{ textAlign: "center" }}>
                <GreenRadio
                  // checked={inspFailed === true}
                  checked={inspectionResult === "failed"}
                  onChange={e => {
                    if (inspFailed === false) setinspPassed(false);
                    setinspFailed(!inspFailed);
                  }}
                  value="BIT"
                  id="selectedInspectionType"
                  name="radio-button-demo"
                  inputProps={{ "aria-label": "C" }}
                />
                <span>
                  <h4>Did Not Pass</h4>
                </span>
                <div>
                  <h4>Defects Found, Schedule Repairs</h4>
                </div>
              </CardText>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col
            sm={5}
            style={{
              marginLeft: 20,
              paddingBottom: 10,
              paddingTop: 10
            }}
          >
            <Btn
              className=" btn-lg btn-block mt-2"
              color="primary"
              // onClick={() => submitHandler("passed", inspType)}
              onClick={() => {
                setInspectionResult("passed");
                setScreen(5);
              }}
              // disabled={!inspPassed}
              disabled={inspectionResult === "failed"}
            >
              Proceed
            </Btn>
          </Col>
          <Col
            sm={5}
            style={{
              marginLeft: 40,
              paddingBottom: 10,
              paddingTop: 10
            }}
          >
            <Btn
              className=" btn-lg btn-block mt-2"
              color="primary"
              onClick={() => {
                // document.getElementById("head").focus();
                setInspectionResult("failed");
                setScreen(5);
              }}
              // disabled={!inspFailed}
              disabled={inspectionResult === "passed"}
            >
              {/* Add Defect(s) Found */}
              Proceed
            </Btn>
          </Col>
        </Row>
        <div style={{ margin: "0 auto" }}>
          <div style={{ textAlign: "center", fontSize: 18 }}></div>
          <div
            style={{
              color: "black",
              textAlign: "center",
              textDecoration: "underline",
              cursor: "pointer"
            }}
            onClick={() => {
              // document.getElementById("head").focus();
              setScreen(2);
            }}
          >
            Back
          </div>{" "}
        </div>
      </div>
    );
  };

  const RenderListDefectsScreen = () => {
    return (
      <Row className="justify-content-center">
        <Col sm={6}>
          <div style={{ textAlign: "center" }}>
            <h3>{selecttedDefect.name}</h3>
          </div>
          <div style={{ textAlign: "right" }}>
            <Button
              variant="extendedFab"
              style={{
                backgroundColor: "black",
                color: "white",
                fontWeight: "bold"
              }}
              onClick={() => {
                // document.getElementById("head").focus();
                setScreen(5);
              }}
            >
              <AddIcon></AddIcon>
              Add
            </Button>
          </div>
          <div>
            {selecttedDefect.defectsDetailsList.length > 0 && (
              <div
                style={{
                  fontWeight: "bold",
                  borderBottom: "1px solid"
                }}
              >
                List of Defects Added
              </div>
            )}
            {(selecttedDefect.defectsDetailsList.length === 0 ||
              selecttedDefect.defectsDetailsList === undefined) &&
              "No Defects Added Yet"}
          </div>
          <div
            style={{
              minWidth: 100,
              minHeight: 100,
              marginTop: 20
            }}
          >
            {selecttedDefect.defectsDetailsList.map((item, i) => {
              return (
                <div
                  key={i}
                  style={{
                    color: item.redTag ? "red" : "black",
                    borderBottom: "solid",
                    borderSize: "thin"
                  }}
                >
                  <Row>
                    <Col sm={1}>
                      <BuildIcon></BuildIcon>
                    </Col>
                    <Col sm={11}>{item.detail}</Col>
                  </Row>
                </div>
              );
            })}
          </div>
          <Btn
            className=" btn-lg btn-block mt-2"
            color="primary"
            onClick={() => {
              if (selecttedDefect.defectsDetailsList.length > 0) {
                // setDefectsArray(defects.push(selecttedDefect));
                let defs = [...defectsArray];
                defs.push(selecttedDefect);
                setDefectsArray(defs);
              }
              // document.getElementById("head").focus();
              setScreen(3);
            }}
          >
            Back to Defect Categories
          </Btn>
        </Col>
      </Row>
    );
  };

  const RenderObservationsScreen = ({ items }) => {
    let obsArray = items;
    let val = obsArray.length / 3;
    if (vehicleType === "Tractor (Air Brakes)") {
      obsArray = obsArray.filter(a => a.tractor !== false);
      val = obsArray.length / 3;
    } else if (
      ["Pick-up Truck", "Van", "Limousine", "RV-Bus Non-Passenger"].includes(
        vehicleType
      )
    ) {
      obsArray = obsArray.filter(a => a.limo !== false);
      val = obsArray.length / 3;
    } else if (
      ["Bus (Air Brakes)", "Straight Truck (Air Brakes)"].includes(vehicleType)
    ) {
      obsArray = obsArray.filter(a => a.busAB !== false);
      val = obsArray.length / 3;
    } else if (
      ["Bus (Hydraulic Brakes)", "Straight Truck (Hydraulic Brakes)"].includes(
        vehicleType
      )
    ) {
      obsArray = obsArray.filter(a => a.busHB !== false);
      val = obsArray.length / 3;
    } else if (
      [
        "Bus (Air over Hydraulic Brakes)",
        "Straight Truck (Air over Hydraulic Brakes)"
      ].includes(vehicleType)
    ) {
      obsArray = obsArray.filter(a => a.busAOH !== false);
      val = obsArray.length / 3;
    } else if (vehicleType === "Trailer (Air Brakes)") {
      obsArray = obsArray.filter(a => a.trailerAB !== false);
      val = obsArray.length / 3;
    } else if (vehicleType === "Trailer (Hydraulic Brakes)") {
      obsArray = obsArray.filter(a => a.trailerHB !== false);
      val = obsArray.length / 3;
    } else if (vehicleType === "Trailer (Electric Brakes)") {
      obsArray = obsArray.filter(a => a.trailerEB !== false);
      val = obsArray.length / 3;
    }
    return (
      <Row>
        <Col sm={4}>
          <List
            dense
            style={{
              width: "100%"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row"
              }}
            >
              <div
                style={{
                  padding: "3px 0px 0px 70px"
                }}
              >
                <ListItem
                  style={{
                    minWidth: "110px"
                  }}
                >
                  <ListItemText />
                  <ListItemSecondaryAction>OK</ListItemSecondaryAction>
                </ListItem>
              </div>
              <div
                style={{
                  paddingLeft: "16px"
                }}
              >
                DEFECT
              </div>
            </div>
            {obsArray.slice(0, val).map(item => {
              return (
                <div
                  key={item}
                  style={{
                    display: "flex",
                    flexDirection: "row"
                  }}
                >
                  <div>
                    <ListItem
                      style={{
                        minWidth: "197px"
                      }}
                    >
                      <ListItemText id={item.Obs}>{item.Obs}</ListItemText>
                      <ListItemSecondaryAction>
                        {SelectedObservations.includes(item.Obs) ? (
                          <Checkbox
                            edge="end"
                            onChange={() => handleObservatations(item.Obs)}
                            disabled={DefectiveObservations.includes(item.Obs)}
                            checked={true}
                          />
                        ) : (
                          <Checkbox
                            edge="end"
                            onChange={() => handleObservatations(item.Obs)}
                            disabled={DefectiveObservations.includes(item.Obs)}
                          />
                        )}
                      </ListItemSecondaryAction>
                    </ListItem>
                  </div>
                  <div>
                    {DefectiveObservations.includes(item.Obs) ? (
                      <Checkbox
                        edge="end"
                        indeterminate
                        disabled={
                          SelectedObservations.includes(item.Obs) ||
                          disabled.defective.includes(item.Obs)
                        }
                        checked={true}
                        onChange={() => handleSelectedDefect(item)}
                      />
                    ) : (
                      <Checkbox
                        edge="end"
                        indeterminate
                        disabled={
                          SelectedObservations.includes(item.Obs) ||
                          disabled.defective.includes(item.Obs)
                        }
                        onChange={() => handleSelectedDefect(item)}
                        checked={false}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </List>
        </Col>
        <Col sm={4}>
          <List
            dense
            style={{
              width: "100%",
              maxWidth: "360"
              // backgroundColor: theme.palette.background.paper,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row"
              }}
            >
              <div
                style={{
                  padding: "3px 0px 0px 70px"
                }}
              >
                <ListItem
                  style={{
                    minWidth: "110px"
                  }}
                >
                  <ListItemText />
                  <ListItemSecondaryAction>OK</ListItemSecondaryAction>
                </ListItem>
              </div>
              <div
                style={{
                  paddingLeft: "16px"
                }}
              >
                DEFECT
              </div>
            </div>
            {obsArray.slice(val, 2 * val).map(item => {
              return (
                <div
                  key={item}
                  style={{
                    display: "flex",
                    flexDirection: "row"
                  }}
                >
                  <div>
                    <ListItem
                      style={{
                        minWidth: "197px"
                      }}
                    >
                      <ListItemText id={item.Obs}>{item.Obs}</ListItemText>
                      <ListItemSecondaryAction>
                        {SelectedObservations.includes(item.Obs) ? (
                          <Checkbox
                            edge="end"
                            onChange={() => handleObservatations(item.Obs)}
                            disabled={DefectiveObservations.includes(item.Obs)}
                            checked={true}
                          />
                        ) : (
                          <Checkbox
                            edge="end"
                            onChange={() => handleObservatations(item.Obs)}
                            disabled={DefectiveObservations.includes(item.Obs)}
                          />
                        )}
                      </ListItemSecondaryAction>
                    </ListItem>
                  </div>
                  <div>
                    {DefectiveObservations.includes(item.Obs) ? (
                      <Checkbox
                        edge="end"
                        indeterminate
                        disabled={
                          SelectedObservations.includes(item.Obs) ||
                          disabled.defective.includes(item.Obs)
                        }
                        checked={true}
                        onChange={() => handleSelectedDefect(item)}
                      />
                    ) : (
                      <Checkbox
                        edge="end"
                        indeterminate
                        disabled={
                          SelectedObservations.includes(item.Obs) ||
                          disabled.defective.includes(item.Obs)
                        }
                        onChange={() => handleSelectedDefect(item)}
                        checked={false}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </List>
        </Col>
        <Col sm={4}>
          <List
            dense
            style={{
              width: "100%",
              maxWidth: "360"
              // backgroundColor: theme.palette.background.paper,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row"
              }}
            >
              <div
                style={{
                  padding: "3px 0px 0px 70px"
                }}
              >
                <ListItem
                  style={{
                    minWidth: "110px"
                  }}
                >
                  <ListItemText />
                  <ListItemSecondaryAction>OK</ListItemSecondaryAction>
                </ListItem>
              </div>
              <div
                style={{
                  paddingLeft: "16px"
                }}
              >
                DEFECT
              </div>
            </div>
            {obsArray.slice(2 * val, 3 * val).map(item => {
              return (
                <div
                  key={item}
                  style={{
                    display: "flex",
                    flexDirection: "row"
                  }}
                >
                  <div>
                    <ListItem
                      style={{
                        minWidth: "197px"
                      }}
                    >
                      <ListItemText id={item.Obs}>{item.Obs}</ListItemText>
                      <ListItemSecondaryAction>
                        {SelectedObservations.includes(item.Obs) ? (
                          <Checkbox
                            edge="end"
                            onChange={() => handleObservatations(item.Obs)}
                            disabled={DefectiveObservations.includes(item.Obs)}
                            checked={true}
                          />
                        ) : (
                          <Checkbox
                            edge="end"
                            onChange={() => handleObservatations(item.Obs)}
                            disabled={DefectiveObservations.includes(item.Obs)}
                          />
                        )}
                      </ListItemSecondaryAction>
                    </ListItem>
                  </div>
                  <div>
                    {DefectiveObservations.includes(item.Obs) ? (
                      <Checkbox
                        edge="end"
                        indeterminate
                        disabled={
                          SelectedObservations.includes(item.Obs) ||
                          disabled.defective.includes(item.Obs)
                        }
                        checked={true}
                        onChange={() => handleSelectedDefect(item)}
                      />
                    ) : (
                      <Checkbox
                        edge="end"
                        indeterminate
                        disabled={
                          SelectedObservations.includes(item.Obs) ||
                          disabled.defective.includes(item.Obs)
                        }
                        onChange={() => handleSelectedDefect(item)}
                        checked={false}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </List>
        </Col>
      </Row>
    );
  };

  const RenderReviewSubmitScreen = () => {
    return (
      <div>
        <Row style={{ marginTop: "-25px" }}>
          <Col sm={3} />
          <Col sm={6} style={{ display: "flex", justifyContent: "center" }}>
            <h3>Review and Submit</h3>
          </Col>
          <Col sm={3} />
        </Row>
        <Divider variant="middle" />
        <Row>
          <Col sm={7}>
            <div style={{ fontWeight: "bold", margin: 2 }}>
              <Row>
                <Col>
                  Started On:{" "}
                  {
                    moment(new Date(startDate))
                      .toISOString()
                      .split("T")[0]
                  }
                  <IconButton
                    aria-label="edit"
                    onClick={() => {
                      setDialog(true);
                      setDateEditor("startDate");
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Col>
              </Row>
            </div>
            <div style={{ fontWeight: "bold", margin: 2 }}>
              <Row>
                <Col>
                  Ended at:{" "}
                  {
                    moment(new Date(endDate))
                      .toISOString()
                      .split("T")[0]
                  }
                  <IconButton
                    aria-label="edit"
                    onClick={() => {
                      setDialog(true);
                      setDateEditor("endDate");
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Col>
              </Row>
            </div>
          </Col>
          <Col sm={5}>
            {/* <div style={{ fontWeight: "bold" }}>
                        <Row>
                          <Col>
                            <form
                              style={{
                                display: "flex",
                                flexWrap: "wrap"
                              }}
                              noValidate
                              autoComplete="off"
                            >
                              <TextField
                                id="mileage"
                                label="Current Mileage (KM)"
                                type="number"
                                value={observedMileage}
                                onChange={e => {
                                  setMileage(e.target.value);
                                  observedMileage = e.target.value;
                                  setMileage(observedMileage);
                                }}
                                margin="none"
                                variant="outlined"
                              />{" "}
                            </form>
                          </Col>
                        </Row>
                      </div> */}
            <div>
              <Row>
                <Col>
                  <FormGroup>
                    <span style={{ margin: 0, cursor: "pointer" }}>
                      (
                      {!formFile.name && (
                        <div
                          className="upload-btn-wrapper"
                          style={{
                            marginBottom: -8,
                            cursor: "pointer"
                          }}
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              color: "blue",
                              textDecoration: "underline"
                            }}
                          >
                            Upload Form
                          </span>
                          <input
                            id="def-pic"
                            type="file"
                            name="formfile"
                            onChange={e => {
                              let file = e.target.files[0];
                              setFormFile(file);
                            }}
                          />
                        </div>
                      )}
                      {formFile.name && (
                        <span>
                          <span
                            className="badge badge-pill badge-primary"
                            style={{ fontSize: 16 }}
                          >
                            {formFile.name}
                            <span
                              style={{ margin: 0, cursor: "pointer" }}
                              onClick={() => setFormFile({})}
                            >
                              {" "}
                              x
                            </span>
                          </span>
                        </span>
                      )}
                      )
                    </span>
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <div>
              <Row>
                <Col>
                  <FormGroup>
                    <span style={{ margin: 0, cursor: "pointer" }}>
                      (
                      {!reportFile.name && (
                        <div
                          className="upload-btn-wrapper"
                          style={{
                            marginBottom: -8,
                            cursor: "pointer"
                          }}
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              color: "blue",
                              textDecoration: "underline"
                            }}
                          >
                            Upload Report
                          </span>
                          <input
                            id="def-pic"
                            type="file"
                            name="reportFile"
                            onChange={e => {
                              let file = e.target.files[0];
                              setReportFile(file);
                            }}
                          />
                        </div>
                      )}
                      {reportFile.name && (
                        <span>
                          <span
                            className="badge badge-pill badge-primary"
                            style={{ fontSize: 16 }}
                          >
                            {reportFile.name}
                            <span
                              style={{ margin: 0, cursor: "pointer" }}
                              onClick={() => setReportFile({})}
                            >
                              {" "}
                              x
                            </span>
                          </span>
                        </span>
                      )}
                      )
                    </span>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <Divider variant="middle" />
        <Row>
          {listDefects.map((selecttedDefect, index) => {
            let redTagCount = 0;
            selecttedDefect.defectsDetailsList.map(obj => {
              if (obj.redTag) redTagCount++;
            });
            return selecttedDefect.defectsDetailsList.length > 0 ? (
              <Col sm={6} md={3} style={cardStyle}>
                <div
                  style={{
                    fontSize: "10px",
                    textDecoration: "bold"
                  }}
                >
                  {selecttedDefect.name}
                </div>
                <div
                  style={{
                    fontSize: "13px"
                  }}
                >
                  {selecttedDefect.Obs}
                </div>
                <div>
                  <span style={{ margin: 5 }}>
                    Defects: {selecttedDefect.defectsDetailsList.length}
                  </span>
                  {redTagCount > 0 && (
                    <span style={{ margin: 5 }}>RedTag :{redTagCount}</span>
                  )}
                </div>

                <div
                  style={{
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer"
                  }}
                  onClick={() => showModal(index)}
                >
                  See Defect Detail
                </div>
              </Col>
            ) : null;
          })}
        </Row>
      </div>
    );
  };

  const RenderCommonView = () => {
    return (
      <div className="text-center">
        <Row className="px-3 justify-content-center">
          <Col md={4}>
            {screen === 2 && (
              <React.Fragment>
                <Btn
                  className=" btn-lg btn-block my-2 mx-2"
                  color="primary"
                  onClick={() => {
                    // if (inspectionResult === "passed") {
                    //   showDefetsDetail();
                    //   setScreen(5);
                    // } else {
                    //   showDefetsDetail();
                    //   setScreen(5);
                    // }
                    if (
                      defectsArray.length > 0 &&
                      DefectiveObservations.length > 0
                    ) {
                      setInspectionResult("failed");
                      showDefetsDetail();
                      setScreen(1);
                    } else {
                      setInspectionResult("passed");
                      showDefetsDetail();
                      setScreen(1);
                    }
                  }}
                >
                  Next
                </Btn>
                <div style={{ margin: "0 auto" }}>
                  <div style={{ textAlign: "center", fontSize: 18 }}></div>
                  <div
                    style={{
                      color: "black",
                      textAlign: "center",
                      textDecoration: "underline",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      // document.getElementById("head").focus();
                      props.history.goBack();
                    }}
                  >
                    Back
                  </div>{" "}
                </div>
              </React.Fragment>
            )}
            {screen === 3 && (
              <React.Fragment>
                <Btn
                  className=" btn-lg btn-block my-2 mx-2"
                  color="primary"
                  onClick={() => {
                    showDefetsDetail();
                  }}
                >
                  Next
                </Btn>
                <div style={{ margin: "0 auto" }}>
                  <div style={{ textAlign: "center", fontSize: 18 }}></div>
                  <div
                    style={{
                      color: "black",
                      textAlign: "center",
                      textDecoration: "underline",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      // document.getElementById("head").focus();

                      setScreen(screen - 1);
                    }}
                  >
                    Back
                  </div>{" "}
                </div>
              </React.Fragment>
            )}
            {screen === 5 && (
              <div>
                <Btn
                  className=" btn-lg btn-block mt-2"
                  color="primary"
                  onClick={() => {
                    //submit insp with defectsArray
                    //call handleSubmit with arg="Failed" and call handleSubmit for passed and pass arg=Passed
                    submitHandler(inspectionResult, inspType);
                    // handleSubmit("failed");
                  }}
                >
                  Submit and Close
                </Btn>
                {inspectionResult !== "passed" && (
                  <Btn
                    className=" btn-lg btn-block mt-2"
                    color="link"
                    onClick={() => {
                      // document.getElementById("head").focus();
                      setScreen(2);
                    }}
                  >
                    Add another defect
                  </Btn>
                )}
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  };

  const RenderSelectDefectScreen = () => {
    return (
      <div>
        {props.match.params.type === "insp" && <h3>Did not pass</h3>}
        <Row>
          {vehicleDefects.map((item, i) => {
            let redTagCount = 0;
            item.defectsDetailsList.map(obj => {
              if (obj.redTag) redTagCount++;
            });
            return (
              <Col
                key={i}
                sm={3}
                style={cardStyle}
                onClick={() => {
                  setSelectedDefect(item);
                  setScreen(4);
                }}
              >
                <Label check>
                  <span>
                    <h4> {item.name}</h4>
                  </span>
                </Label>
                <div>
                  <span style={{ margin: 5 }}>
                    Defects: {item.defectsDetailsList.length}
                  </span>
                  {redTagCount > 0 && (
                    <span style={{ margin: 5 }}>RedTag :{redTagCount}</span>
                  )}
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  };
  const RenderDefectsListModal = () => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={() => setOpen(false)}
      >
        <div
          style={{
            position: "absolute",
            width: "auto",
            backgroundColor: "white",
            // border: '2px solid #000',
            boxShadow: 5,
            padding: 25,
            top: 100,
            left: 200
          }}
        >
          <div id="simple-modal-title" style={{ float: "left" }}>
            Total Defects:{" "}
            {listDefects[index] != undefined &&
              listDefects[index].defectsDetailsList.length}
          </div>
          <div style={{ float: "right" }} onClick={() => setOpen(false)}>
            <HighlightOffIcon></HighlightOffIcon>
          </div>
          <Table padding="checkbox">
            <TableHead>
              <TableCell>Defect Type</TableCell>
              <TableCell>Defect Category</TableCell>
              <TableCell>Defect Description</TableCell>
              <TableCell>Priority</TableCell>
              <TableCell>Red Tag</TableCell>
              <TableCell></TableCell>
            </TableHead>
            <TableBody>
              {listDefects[index] != undefined &&
                listDefects[index].defectsDetailsList.map((defect, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell>{listDefects[index].Obs}</TableCell>
                      <TableCell>{listDefects[index].name}</TableCell>
                      <TableCell>{defect.detail}</TableCell>
                      <TableCell>{defect.priority.value}</TableCell>
                      <TableCell style={{ color: "red" }}>
                        {defect.redTag ? "true" : "false"}
                      </TableCell>
                      <TableCell>
                        <span
                          style={{
                            margin: 5,
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer"
                          }}
                          onClick={() => removeDefect(i)}
                        >
                          Remove
                        </span>
                        <span> | </span>
                        <span
                          style={{
                            margin: 5,
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer"
                          }}
                          onClick={() => showEdit(i)}
                        >
                          Edit
                        </span>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
      </Modal>
    );
  };

  return (
    <Container style={{ marginTop: -15 }}>
      <DateEditorDialog />
      <AnnualCheckDialog />
      <RemoveDialog />
      <Row className="justify-content-left">
        <Col lg={12}>
          <Card style={{ padding: 0 }}>
            <CardHeader style={{ backgroundColor: "black", color: "white" }}>
              <HeaderDisplay />
            </CardHeader>
            <CardBody style={{ padding: 25 }}>
              <hr style={{ marginTop: -20 }} />
              {(screen === 2 || screen === "Observations") && (
                <Row style={{ padding: "25px", backgroundColor: "#F9F9F9" }}>
                  <RenderObservationsScreen items={InspectionCheckData} />
                </Row>
              )}
              {(screen === 1 || screen === "InspResult") && (
                <div>
                  <RenderInspResultScreen />
                </div>
              )}

              {(screen === 3 || screen === "SelectDefect") && (
                <div>
                  <RenderSelectDefectScreen />
                </div>
              )}

              {(screen === -1 || screen === "ListDefects") && (
                <RenderListDefectsScreen />
              )}

              {(screen === 4 || screen === "AddReportDefect") && (
                <div>
                  <Row className="justify-content-center">
                    <Col sm={6}>
                      <div style={{ textAlign: "center" }}>
                        {" "}
                        <h3>{selecttedDefect.name}</h3>
                        Report Defect
                      </div>
                      <div style={{ margin: "auto 0" }}>
                        <TextField
                          id="outlined-multiline-static"
                          label="Defect Description *"
                          multiline
                          rows="4"
                          defaultValue=""
                          value={detail}
                          style={{
                            width: "100%"
                          }}
                          margin="normal"
                          onChange={e => setDetail(e.target.value)}
                          // onBlur={e => runTimeChek(e)}
                          variant="outlined"
                        />
                      </div>
                      <div style={{ textAlign: "left" }}>
                        Priority
                        <div style={{ margin: "auto 0" }}>
                          <Select
                            required
                            value={priority}
                            id="priority"
                            onChange={val => setPriority(val)}
                            // onBlur={e => runTimeChek(e)}
                            placeholder="Priority *"
                            options={priorityOptions}
                          />
                        </div>
                        <div>
                          <div className="upload-btn-wrapper">
                            <Button
                              variant="contained"
                              className={classes.blackButton}
                              style={{
                                margin: 10,
                                backgroundColor: "black",
                                color: "white"
                              }}
                              onClick={e => {
                                e.preventDefault();
                                document.getElementById("def-pic").click();
                              }}
                            >
                              <CloudUploadIcon />
                              Upload Image('s)
                            </Button>
                            <input
                              id="def-pic"
                              type="file"
                              name="myfile"
                              onChange={e => fileSelect(e)}
                            />
                          </div>
                        </div>
                        <Row>
                          {files.map((File, index) => {
                            return (
                              <span
                                key={index}
                                className="badge badge-pill badge-primary"
                                style={{ fontSize: 16, margin: 10 }}
                              >
                                {File && File.name}
                                <span
                                  style={{ margin: 5, cursor: "pointer" }}
                                  onClick={() => removeFile(File, index)}
                                >
                                  <HighlightOffIcon></HighlightOffIcon>
                                </span>
                              </span>
                            );
                          })}
                        </Row>
                        <div
                          style={{
                            marginLeft: 12
                          }}
                        >
                          <Label
                            check
                            style={{
                              color: "black",
                              marginTop: 20,
                              marginLeft: 12
                            }}
                          >
                            <Input
                              type="checkbox"
                              value={select}
                              onChange={e => setSelect(e.target.checked)}
                            />{" "}
                            Place vehicle out of service
                          </Label>
                        </div>
                      </div>

                      {mode === "Add" && (
                        <Btn
                          className=" btn-lg btn-block mt-2"
                          color="primary"
                          onClick={() => addDefectDetail()}
                        >
                          ADD
                        </Btn>
                      )}
                      {mode === "Edit" && (
                        <Btn
                          className=" btn-lg btn-block mt-2"
                          color="primary"
                          onClick={() => _closeEdit()}
                        >
                          Edit
                        </Btn>
                      )}
                      <div style={{ margin: "0 auto" }}>
                        <div
                          style={{ textAlign: "center", fontSize: 18 }}
                        ></div>
                        <div
                          style={{
                            color: "black",
                            textAlign: "center",
                            textDecoration: "underline",
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            setDetail("");
                            setPriority("");
                            setSelect(false);
                            // setScreen(3);
                            setSelectedDefect({});
                            setScreen(2);
                          }}
                        >
                          Back
                        </div>{" "}
                      </div>
                    </Col>
                  </Row>

                  {selecttedDefect.defectsDetailsList &&
                    selecttedDefect.defectsDetailsList.length > 0 && (
                      <Row>
                        <div
                          style={{
                            // position: "absolute",
                            width: "auto",
                            backgroundColor: "white",
                            // border: '2px solid #000',
                            boxShadow: 5,
                            padding: 25,
                            top: 100,
                            left: 200
                          }}
                        >
                          <div
                            id="simple-modal-title"
                            style={{ float: "left" }}
                          >
                            Total Defects:{" "}
                            {selecttedDefect.defectsDetailsList.length}
                          </div>
                          {/* <div
                        style={{ float: "right" }}
                        onClick={() => setOpen(false)}
                      >
                        <HighlightOffIcon></HighlightOffIcon>
                      </div> */}
                          <Table padding="checkbox">
                            <TableHead>
                              <TableCell>Defect Type</TableCell>
                              <TableCell>Defect Category</TableCell>
                              <TableCell>Defect Description</TableCell>
                              <TableCell>Priority</TableCell>
                              <TableCell>Red Tag</TableCell>
                              <TableCell></TableCell>
                            </TableHead>
                            <TableBody>
                              {selecttedDefect.defectsDetailsList.map(
                                (defect, i) => {
                                  return (
                                    <TableRow key={i}>
                                      <TableCell>
                                        {selecttedDefect.Obs}
                                      </TableCell>
                                      <TableCell>
                                        {selecttedDefect.name}
                                      </TableCell>
                                      <TableCell>{defect.detail}</TableCell>
                                      <TableCell>
                                        {defect.priority.value}
                                      </TableCell>
                                      <TableCell style={{ color: "red" }}>
                                        {defect.redTag ? "true" : "false"}
                                      </TableCell>
                                      <TableCell>
                                        <span
                                          style={{
                                            margin: 5,
                                            color: "blue",
                                            textDecoration: "underline",
                                            cursor: "pointer"
                                          }}
                                          onClick={() => {
                                            // _removeDefect(i);
                                            setTobeRemoved(i);
                                            setRemoveDialog(true);
                                          }}
                                        >
                                          Remove
                                        </span>
                                        <span> | </span>
                                        <span
                                          style={{
                                            margin: 5,
                                            color: "blue",
                                            textDecoration: "underline",
                                            cursor: "pointer"
                                          }}
                                          onClick={() => {
                                            setMode("Edit");
                                            _showEdit(i);
                                          }}
                                        >
                                          Edit
                                        </span>
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                              )}
                            </TableBody>
                          </Table>
                        </div>
                      </Row>
                    )}
                </div>
              )}

              {(screen === 5 || screen === "ReviewSubmit") && (
                <RenderReviewSubmitScreen />
              )}

              {(screen === 6 || screen === "EditReportDefect") && (
                <Row className="justify-content-center">
                  <Col sm={6}>
                    <div style={{ textAlign: "center" }}>
                      {" "}
                      <h3>{selecttedDefect.name}</h3>
                      Report Defect
                    </div>
                    <div style={{ margin: "auto 0" }}>
                      <TextField
                        id="outlined-multiline-static"
                        label="Defect Description *"
                        multiline
                        rows="4"
                        defaultValue=""
                        style={{
                          width: "100%"
                        }}
                        value={detail}
                        margin="normal"
                        onChange={e => setDetail(e.target.value)}
                        variant="outlined"
                      />
                    </div>
                    <div style={{ textAlign: "left" }}>
                      Priority
                      <div style={{ margin: "auto 0" }}>
                        <Select
                          required
                          value={priority}
                          id="priority"
                          onChange={val => setPriority(val)}
                          placeholder="Priority *"
                          options={priorityOptions}
                        />
                      </div>
                      <div>
                        <div className="upload-btn-wrapper">
                          <Button
                            variant="contained"
                            className={classes.blackButton}
                            style={{
                              margin: 10,
                              backgroundColor: "black",
                              color: "white"
                            }}
                            onClick={e => {
                              e.preventDefault();
                              document.getElementById("def-pic").click();
                            }}
                          >
                            <CloudUploadIcon />
                            Upload Image('s)
                          </Button>
                          <input
                            id="def-pic"
                            type="file"
                            name="myfile"
                            onChange={e => fileSelect(e)}
                          />
                        </div>
                      </div>
                      <Row>
                        {files.map((File, index) => {
                          return (
                            <span
                              key={index}
                              className="badge badge-pill badge-primary"
                              style={{ fontSize: 16, margin: 10 }}
                            >
                              {File.key ? File.key : File.name}
                              <span
                                style={{ margin: 5, cursor: "pointer" }}
                                onClick={() => removeFile(File, index)}
                              >
                                <HighlightOffIcon></HighlightOffIcon>
                              </span>
                            </span>
                          );
                        })}
                      </Row>
                      <div
                        style={{
                          marginLeft: 12
                        }}
                      >
                        <Label
                          check
                          style={{
                            color: "black",
                            marginTop: 20,
                            marginLeft: 12
                          }}
                        >
                          <Input
                            type="checkbox"
                            checked={select}
                            onChange={() => setSelect(!select)}
                          />{" "}
                          Place vehicle out of service
                        </Label>
                      </div>
                    </div>

                    <Btn
                      className=" btn-lg btn-block mt-2"
                      color="primary"
                      onClick={() => closeEdit()}
                    >
                      Update
                    </Btn>
                    <div style={{ margin: "0 auto" }}>
                      <div style={{ textAlign: "center", fontSize: 18 }}></div>
                      <div
                        style={{
                          color: "black",
                          textAlign: "center",
                          textDecoration: "underline",
                          cursor: "pointer"
                        }}
                        onClick={() => {
                          // document.getElementById("head").focus();
                          setScreen(5);
                        }}
                      >
                        Back
                      </div>{" "}
                    </div>
                  </Col>
                </Row>
              )}

              <RenderCommonView />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <RenderDefectsListModal />
    </Container>
  );
};
const previewStyle = {
  display: "inline",
  width: 100,
  height: 100
};

const classes = {
  blackButton: {
    "&,& a,& a:hover,& a:focus": {
      padding: "10px",

      color: "white",
      borderRadius: "5px",
      backgroundColor: "#000000"
    }
  },

  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardHeader: {
    backgroundColor: "#000000"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};
const cardStyle = {
  display: "block",
  width: "100%",
  height: "100%",
  padding: "5px",
  backgroundColor: "white",
  cursor: "pointer",
  margin: "15px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  transition: "0.3s",
  borderRadius: "5px",
  "&:hover": {
    boxShadow: "0 8px 16px 0 rgba(0,0,0,0.2)"
  }
};
const mapDispatchToProps = dispatch => {
  return {
    storeProfile: data => dispatch(actionTypes.storeProfile(data))
    //updateProfile: data => dispatch(actionTypes.updateProfile(data))
  };
};
const mapStateToProps = state => {
  return {
    user: state.config.user,
    loading: state.inspections.loading,
    data: state.inspections.data,
    client: state.config.client,
    profile: state.config.profile
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(InspectionList));



// WEBPACK FOOTER //
// ./src/inspection/inspectionList.jsx